import * as React from 'react';

import { FlashMessage, FlashMessageType } from '~/src/atomic/mol.flash-message';
import { FlashMessageContext, FlashMessageContextContent } from './flash-message.context';
import { Col, Row } from '~/src/atomic/obj.grid';
import { Body } from '~/src/atomic/atm.typography';
import { FlashMessageWrapperStyled } from './flash-message-provider.component.style';

export const FlashMessageProvider: React.FC<React.PropsWithChildren<any>> = (props) => {
  const [message, setMessage] = React.useState<FlashMessageContextContent>({ hidden: true });

  const showMessage = React.useCallback((type: FlashMessageType, content: string) => {
    const newMessage = { type, content, hidden: false };
    setMessage(newMessage);
  }, []);

  const hideMessage = React.useCallback(() => {
    const newMessage = { hidden: true };
    setMessage(newMessage);
  }, []);

  return (
    <FlashMessageContext.Provider value={{ message, showMessage, hideMessage }}>
      {props.children}
      {!message.hidden && message.content && (
        <FlashMessageWrapperStyled>
          <Row justify="center">
            <Col xs={12} lg={12}>
              <FlashMessage type={message.type} onClose={hideMessage}>
                <Body id="flash-message-text">{message.content}</Body>
              </FlashMessage>
            </Col>
          </Row>
        </FlashMessageWrapperStyled>
      )}
    </FlashMessageContext.Provider>
  );
};
